import React from 'react'
import './TaskViews.scss'

interface TaskWeekViewProps {
  lifeSpace?: 'personal' | 'work' | 'home' | 'all'
}

export const TaskWeekView: React.FC<TaskWeekViewProps> = () => {
  return (
    <div className="task-view">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">Demnächst</h2>
        </div>
      </div>
    </div>
  )
}
